// eslint-disable-next-line import/no-relative-packages
import theme from "../../../../apps/dashboard/src/helpers/theme";

export const paginationButtonsSxConfig = {
  cursor: "pointer",
  height: "50px",
  width: "250px",
  borderRadius: "25px",
  fontSize: "18px",
  backgroundColor: theme.colors.gray[700],
  color: theme.colors.white,
  "&:hover": {
    backgroundColor: theme.colors.gray[500],
  },
};
